/**
 * Destination content for non-dashboard routes that don't yet have a
 * dedicated implementation. Each entry feeds the DestinationPlaceholder
 * to keep the design language consistent while individual designs are
 * approved.
 *
 * Iteration 18 · Operational Completeness: the `voyage` entry was removed
 * because the Voyage route is now served by the operational
 * VoyageOverview component regardless of lifecycle stage. Adding a
 * placeholder entry here for any live workspace is a regression risk —
 * only unbuilt destinations belong in this map.
 */
export const DESTINATIONS = {
  travelers: null,
  packing: null,
  budget: null,
  binder: null,
  voyages: null,
  settings: null,
};
